export default String.raw`
$(document).ready(()=>{
    $(".mainBanner").each((_i, item) => {
        const $item = $(item);
        const name = $item.data("name");
        const timer = $item.data("timer");
        let isAutoplay = false;
		if (typeof(timer) === "number" && timer >= 0) {
			isAutoplay = true;
		}

        const numberOfSlides = $item.find(".mainBanner__wrapper").data("len");
        let autoplayConfig = false;
        if (isAutoplay) {
            autoplayConfig = { delay: timer };
        }
        const swiper = new Swiper("." + name, {
            speed: 400,
            spaceBetween: 100,
            autoplay: autoplayConfig,
            loop: (numberOfSlides !== 1),
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.' + name + '__next',
                prevEl: '.' + name + '__prev',
            },
            keyboard: {
                enabled: true,
                pageUpDown: true,
            },
            on: {
                init: function () {
                    app.manageTabIndexInsideSlide(this);
                },
                slideChangeTransitionEnd: function () {
                    app.manageTabIndexInsideSlide(this);
                }
            },
            pause: {
				enabled: true,
				el: '.mainBanner-pause-button',
        	}
        });
    });
});
`